import { Box, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import MenuList from "@mui/material/MenuList";
import { useListContext } from "react-admin";
import { hmLightTheme } from "../themes/hmTheme";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import formatTitleText from "../unit/formatTitleText";

const AppMenuTitle = ({ ...props }) => {
  const type = props.type;
  const appCounts = props.count;
  let chipBgColor = "white";
  let textColor = "#000";

  return (
    <Box sx={{ width: "100%" }}>
      {type}
      <Chip
        component="span"
        label={appCounts}
        size="small"
        className="numericText"
        sx={{
          ml: 1,
          float: "right",
          fontFamily: hmLightTheme?.palette?.numberFontFamily,
          backgroundColor: chipBgColor,
          color: textColor,
        }}
      />
    </Box>
  );
};

const ProductListAside = ({ ...props }) => {
  const { filterValues } = useListContext();
  const selected = filterValues.status;
  const totalData = props.totalData;
  const subTotalData = props.subTotalData;
  const division = localStorage.getItem("division");

  const unsecredProductType = [];
  unsecredProductType.push({
    id: 1,
    subtype: "start",
    name: "Small and Simple",
  });
  unsecredProductType.push({
    id: 2,
    subtype: "employee",
    name: "Employment Based",
  });
  unsecredProductType.push({
    id: 19,
    subtype: "purchase",
    name: "Purchase Finance",
  });
  unsecredProductType.push({
    id: 3,
    subtype: "general",
    name: "General Purpose",
  });
  unsecredProductType.push({
    id: 10,
    subtype: "refund",
    name: "Refund Anticipation",
  });

  const securedProductType = [];
  securedProductType.push({
    id: 5,
    subtype: "mortgage",
    name: "Mortgage",
  });
  securedProductType.push({
    id: 6,
    subtype: "car",
    name: "Purchase Car Loan",
  });
  securedProductType.push({
    id: 11,
    subtype: "refinancecar",
    name: "Refinance Car Loan",
  });
  const builderProductType = [];
  builderProductType.push({
    id: 4,
    subtype: "builder",
    name: "Single Term",
  });
  builderProductType.push({
    id: 12,
    subtype: "buildingladder",
    name: "Credit Building Ladder",
  });

  // {
  //     id: "revolving",
  //     name: "Revolving Credit",
  //     child: [{ id: "13", name: "Secured Credit Card" }],
  //   },
  //   {
  //     id: "smallbusiness",
  //     name: "Small Business Loan",
  //     child: [{ id: "18", name: "Micro Loan" }],
  //   },
  //   {
  //     id: "account",
  //     name: "Account Opening",
  //     child: [{ id: "7", name: "Depository Account" }],
  //   },
  const revolvingProductType = [];
  revolvingProductType.push({
    id: 13,
    // subtype: "revolvingcredit",
    subtype: "securedcreditcard",
    name: "Secured Credit Card",
  });
  const smallbusinessProductType = [];
  smallbusinessProductType.push({
    id: 18,
    // subtype: "microloan",
    subtype: "smallmicro",
    name: "Micro Loan",
  });
  const accountProductType = [];
  accountProductType.push({
    id: 7,
    // subtype: "depositoryaccount",
    subtype: "account",
    name: "Depository Account",
  });
  return (
    <>
      <HmSubHeaderTitle
        title="Products"
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "75px",
        }}
      />
      <Card className="hm-list-aside">
        <CardContent sx={{ pt: 1 }}>
          <MenuList component="div" id="list-product-menus">
            {division == "Personal" && (
              <>
                {/* <CustomMenuItemLink
                  to='/products?filter={"status":"unsecured"}'
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Unsecured Loan"
                      count={totalData?.unsecured || 0}
                    />
                  }
                  selected={
                    selected === "unsecured" && !filterValues.filerLoanTypeId
                  }
                  tooltipProps={{
                    title: "Unsecured loan",
                    children: <></>,
                  }}
                /> */}
                <Typography
                  variant="h3"
                  sx={{
                    pl: 0,
                    pt: 1,
                    pb: 1,
                    fontWeight: "bold",
                    mb: 1,
                    color: "#000",
                  }}
                >
                  Unsecured Loan
                  <Chip
                    label={totalData?.unsecured || 0}
                    size="small"
                    className="numericText"
                    sx={{
                      pt: "5px",
                      mr: "0.2em",
                      display: "block",
                      float: "right",
                      fontFamily: hmLightTheme?.palette?.numberFontFamily,
                      backgroundColor: "white",
                      color: "#000",
                      fontWeight: "normal",
                    }}
                  />
                </Typography>

                {unsecredProductType &&
                  unsecredProductType.map((type) => (
                    <CustomMenuItemLink
                      to={`/products?filter={"status":"unsecured","filerLoanTypeId":${type.id}}`}
                      state={{ _scrollToTop: true }}
                      primaryText={
                        <AppMenuTitle
                          type={type.name}
                          count={
                            subTotalData && subTotalData[type.subtype]
                              ? subTotalData[type.subtype]
                              : 0
                          }
                        />
                      }
                      selected={
                        selected === "unsecured" &&
                        filterValues.filerLoanTypeId === type.id
                      }
                      tooltipProps={{
                        title: formatTitleText(type.name),
                        children: <></>,
                      }}
                      // sx={{ "&.MuiMenuItem-root": { pl: "10px" } }}
                    />
                  ))}

                {/* <CustomMenuItemLink
                  to='/products?filter={"status":"secured"}'
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Secured Loan"
                      count={totalData?.secured || 0}
                    />
                  }
                  selected={
                    selected === "secured" && !filterValues.filerLoanTypeId
                  }
                  tooltipProps={{
                    title: "Secured loan",
                    children: <></>,
                  }}
                /> */}
                <hr />
                <Typography
                  variant="h3"
                  sx={{
                    pl: 0,
                    pt: 1,
                    pb: 1,
                    fontWeight: "bold",
                    mb: 1,
                    color: "#000",
                  }}
                >
                  Secured Loan
                  <Chip
                    label={totalData?.secured || 0}
                    size="small"
                    className="numericText"
                    sx={{
                      pt: "5px",
                      mr: "0.2em",
                      display: "block",
                      float: "right",
                      fontFamily: hmLightTheme?.palette?.numberFontFamily,
                      backgroundColor: "white",
                      color: "#000",
                      fontWeight: "normal",
                    }}
                  />
                </Typography>

                {securedProductType &&
                  securedProductType.map((type) => (
                    <CustomMenuItemLink
                      to={`/products?filter={"status":"secured","filerLoanTypeId":${type.id}}`}
                      state={{ _scrollToTop: true }}
                      primaryText={
                        <AppMenuTitle
                          type={type.name}
                          count={
                            subTotalData && subTotalData[type.subtype]
                              ? subTotalData[type.subtype]
                              : 0
                          }
                        />
                      }
                      selected={
                        selected === "secured" &&
                        filterValues.filerLoanTypeId === type.id
                      }
                      tooltipProps={{
                        title: formatTitleText(type.name),
                        children: <></>,
                      }}
                    />
                  ))}
                {/* Credit Building */}
                {/* <CustomMenuItemLink
                  to='/products?filter={"status":"builder"}'
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Credit Building Loan"
                      count={totalData?.builder || 0}
                    />
                  }
                  selected={
                    selected === "builder" && !filterValues.filerLoanTypeId
                  }
                  tooltipProps={{
                    title: "Credit building loan",
                    children: <></>,
                  }}
                /> */}
                <hr />
                <Typography
                  variant="h3"
                  sx={{
                    pl: 0,
                    pt: 1,
                    pb: 1,
                    fontWeight: "bold",
                    mb: 1,
                    color: "#000",
                  }}
                >
                  Credit Building Loan
                  <Chip
                    label={totalData?.builder || 0}
                    size="small"
                    className="numericText"
                    sx={{
                      pt: "5px",
                      mr: "0.2em",
                      display: "block",
                      float: "right",
                      fontFamily: hmLightTheme?.palette?.numberFontFamily,
                      backgroundColor: "white",
                      color: "#000",
                      fontWeight: "normal",
                    }}
                  />
                </Typography>
                {builderProductType &&
                  builderProductType.map((type) => (
                    <CustomMenuItemLink
                      to={`/products?filter={"status":"builder","filerLoanTypeId":${type.id}}`}
                      state={{ _scrollToTop: true }}
                      primaryText={
                        <AppMenuTitle
                          type={type.name}
                          count={
                            subTotalData && subTotalData[type.subtype]
                              ? subTotalData[type.subtype]
                              : 0
                          }
                        />
                      }
                      selected={
                        selected === "builder" &&
                        filterValues.filerLoanTypeId === type.id
                      }
                      tooltipProps={{
                        title: formatTitleText(type.name),
                        children: <></>,
                      }}
                    />
                  ))}
                {/* <CustomMenuItemLink
                  to='/products?filter={"status":"revolvingcredit","filerLoanTypeId":13}'
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Revoiving Credit"
                      count={totalData?.revolvingcredit || 0}
                    />
                  }
                  selected={
                    selected === "revolvingcredit" &&
                    filterValues.filerLoanTypeId === 13
                  }
                  tooltipProps={{
                    title: "Revolving credit",
                    children: <></>,
                  }}
                /> */}
                <hr />
                <Typography
                  variant="h3"
                  sx={{
                    pl: 0,
                    pt: 1,
                    pb: 1,
                    fontWeight: "bold",
                    mb: 1,
                    color: "#000",
                  }}
                >
                  Revolving Credit
                  <Chip
                    label={totalData?.revolvingcredit || 0}
                    size="small"
                    className="numericText"
                    sx={{
                      pt: "5px",
                      mr: "0.2em",
                      display: "block",
                      float: "right",
                      fontFamily: hmLightTheme?.palette?.numberFontFamily,
                      backgroundColor: "white",
                      color: "#000",
                      fontWeight: "normal",
                    }}
                  />
                </Typography>
                {revolvingProductType &&
                  revolvingProductType.map((type) => (
                    <CustomMenuItemLink
                      to={`/products?filter={"status":"revolvingcredit","filerLoanTypeId":${type.id}}`}
                      state={{ _scrollToTop: true }}
                      primaryText={
                        <AppMenuTitle
                          type={type.name}
                          count={
                            subTotalData && subTotalData[type.subtype]
                              ? subTotalData[type.subtype]
                              : 0
                          }
                        />
                      }
                      selected={
                        selected === "revolvingcredit" &&
                        filterValues.filerLoanTypeId === type.id
                      }
                      tooltipProps={{
                        title: formatTitleText(type.name),
                        children: <></>,
                      }}
                    />
                  ))}

                {/* Personal Business */}
                {/* <CustomMenuItemLink
                  to='/products?filter={"status":"smallbusiness", "filerLoanTypeId":18}'
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Small Business Loan"
                      count={totalData?.smallbusiness || 0}
                    />
                  }
                  selected={
                    selected === "smallbusiness" &&
                    filterValues.filerLoanTypeId === 18
                  }
                  tooltipProps={{
                    title: "Small business loan",
                    children: <></>,
                  }}
                /> */}
                <hr />
                <Typography
                  variant="h3"
                  sx={{
                    pl: 0,
                    pt: 1,
                    pb: 1,
                    fontWeight: "bold",
                    mb: 1,
                    color: "#000",
                  }}
                >
                  Small Business Loan
                  <Chip
                    label={totalData?.smallbusiness || 0}
                    size="small"
                    className="numericText"
                    sx={{
                      pt: "5px",
                      mr: "0.2em",
                      display: "block",
                      float: "right",
                      fontFamily: hmLightTheme?.palette?.numberFontFamily,
                      backgroundColor: "white",
                      color: "#000",
                      fontWeight: "normal",
                    }}
                  />
                </Typography>
                {smallbusinessProductType &&
                  smallbusinessProductType.map((type) => (
                    <CustomMenuItemLink
                      to={`/products?filter={"status":"smallbusiness","filerLoanTypeId":${type.id}}`}
                      state={{ _scrollToTop: true }}
                      primaryText={
                        <AppMenuTitle
                          type={type.name}
                          count={
                            subTotalData && subTotalData[type.subtype]
                              ? subTotalData[type.subtype]
                              : 0
                          }
                        />
                      }
                      selected={
                        selected === "smallbusiness" &&
                        filterValues.filerLoanTypeId === type.id
                      }
                      tooltipProps={{
                        title: formatTitleText(type.name),
                        children: <></>,
                      }}
                    />
                  ))}

                {/* Account Open */}
                {/* <CustomMenuItemLink
                  to='/products?filter={"status":"account","filerLoanTypeId":7}'
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Account Opening"
                      count={totalData?.account || 0}
                    />
                  }
                  selected={
                    selected === "account" && filterValues.filerLoanTypeId === 7
                  }
                  tooltipProps={{
                    title: "Account opening",
                    children: <></>,
                  }}
                /> */}
                <hr />
                <Typography
                  variant="h3"
                  sx={{
                    pl: 0,
                    pt: 1,
                    pb: 1,
                    fontWeight: "bold",
                    mb: 1,
                    color: "#000",
                  }}
                >
                  Account opening
                  <Chip
                    label={totalData?.account || 0}
                    size="small"
                    className="numericText"
                    sx={{
                      pt: "5px",
                      mr: "0.2em",
                      display: "block",
                      float: "right",
                      fontFamily: hmLightTheme?.palette?.numberFontFamily,
                      backgroundColor: "white",
                      color: "#000",
                      fontWeight: "normal",
                    }}
                  />
                </Typography>
                {accountProductType &&
                  accountProductType.map((type) => (
                    <CustomMenuItemLink
                      to={`/products?filter={"status":"account","filerLoanTypeId":${type.id}}`}
                      state={{ _scrollToTop: true }}
                      primaryText={
                        <AppMenuTitle
                          type={type.name}
                          count={
                            subTotalData && subTotalData[type.subtype]
                              ? subTotalData[type.subtype]
                              : 0
                          }
                        />
                      }
                      selected={
                        selected === "account" &&
                        filterValues.filerLoanTypeId === type.id
                      }
                      tooltipProps={{
                        title: formatTitleText(type.name),
                        children: <></>,
                      }}
                    />
                  ))}
              </>
            )}
            {division == "Business" && (
              <>
                {/* Unsecured */}
                <CustomMenuItemLink
                  to='/products?filter={"status":"unsecured"}'
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle type="Unsecured" count={totalData.products} />
                  }
                  selected={selected === "unsecured"}
                  tooltipProps={{
                    title: "Unsecured loan",
                    children: <></>,
                  }}
                />
                {/* Secured */}
                <CustomMenuItemLink
                  to='/products?filter={"status":"secured"}'
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle type="Secured" count={totalData.products} />
                  }
                  selected={selected === "secured"}
                  tooltipProps={{
                    title: "Secured loan",
                    children: <></>,
                  }}
                />
              </>
            )}
          </MenuList>
        </CardContent>
      </Card>
    </>
  );
};

export default ProductListAside;
